/**
 * В API `moduleSlug` — строка: так и задумано, потому что помимо встроенных модулей есть
 * кастомные модули проекта со своим уникальным слагом и изолированным контекстом данных.
 * Этот enum — только фиксированный набор встроенных слагов (доступ участников, превью и т.п.).
 */
export enum ProjectModuleSlugEnum {
  AboutProject = 'about_project',
  ProjectMembers = 'project_members',
  ProjectManagement = 'project_management',
  Supporters = 'supporters',
  ProjectNews = 'project_news',
  ProjectSurvey = 'project_survey',
  ProjectOrgMail = 'project_org_mail',
  ProjectSpeeches = 'project_speeches',
  ProjectCalendar = 'project_calendar',
}
